import useHubDbRows from './useHubDbRows';
import useDynamicPageInfo from './useDynamicPageInfo';
const useTitleConfigOverride = () => {
  const {
    isCrmDynamicPage,
    isHubDbPage,
    hubDbTableId,
    hubDbRowId
  } = useDynamicPageInfo();
  const {
    hubDbRow
  } = useHubDbRows({
    hubDbTableId,
    hubDbRowId
  });
  return {
    title: isHubDbPage && hubDbRow ? hubDbRow.name : undefined,
    canEdit: !isHubDbPage && !isCrmDynamicPage
  };
};
export default useTitleConfigOverride;